import { HStack, Stack, Text, VStack } from '@chakra-ui/react'
import { OwnerSubmitType } from 'context/types'

import { CustomFileCheck } from 'components/CustomFileCheck'
import { FileControl } from 'components/InputCustom'

type Props = {
  values: OwnerSubmitType
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void
}

export const StepTwo: React.FC<Props> = ({ values: { fileThree }, setFieldValue }) => {

  return (
    <VStack w={'full'} spacing={4} justifyContent={'flex-start'} alignItems={'flex-start'}>
      <Text variant={{ base: 'MD_SB', md: 'LG_SB' }}>2. Adjunta cualquiera de estos documentos</Text>
      <VStack w={'full'} spacing={0}>
        <HStack w={'full'} justifyContent={'flex-start'}>
          <Text variant={{ base: 'SM_SB', md: 'MD_SB' }}>Formatos permitidos:</Text>
          <Text variant={{ base: 'SM', md: 'MD' }}>JPG, JPEG, PNG, PDF </Text>
        </HStack>
        <HStack w={'full'}>
          <Text variant={{ base: 'SM_SB', md: 'MD_SB' }}>Tamaño máximo cada foto:</Text>
          <Text variant={{ base: 'SM', md: 'MD' }}>2 MB</Text>
        </HStack>
      </VStack>
      <VStack w={'full'} spacing={0} alignItems={'flex-start'}>
        <Text variant={{ base: 'SM', md: 'MD' }}>·Documento de compra venta</Text>
        <Text variant={{ base: 'SM', md: 'MD' }}>·Documento del vehículo</Text>
      </VStack>
      <Stack
        w={'full'}
        alignItems={'flex-start'}
        justifyContent={'center'}
        direction={{ base: 'column', md: 'row' }}
        spacing='24px'>
        {fileThree && <CustomFileCheck text={fileThree.name} onClick={() => setFieldValue('fileThree', null)} />}
      </Stack>
      <FileControl name='fileThree' buttonProps={{ disabled: !!fileThree }} />
    </VStack>
  )
}
